import { render, staticRenderFns } from "./FinishUpgradeDialog.vue?vue&type=template&id=b8e6e32c&scoped=true&"
import script from "./FinishUpgradeDialog.vue?vue&type=script&lang=js&"
export * from "./FinishUpgradeDialog.vue?vue&type=script&lang=js&"
import style0 from "./FinishUpgradeDialog.vue?vue&type=style&index=0&id=b8e6e32c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e6e32c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})
